import React from "react";
import { MenuItem, Select, FormControl } from "@mui/material";

const generateTimes = () => {
  const times = [];
  let start = 0;
  const end = 24 * 60;
  while (start < end) {
    const hours = Math.floor(start / 60);
    const minutes = start % 60;

    // 24h format for value (e.g. "13:00")
    const valueHours = hours.toString().padStart(2, "0");
    const valueMinutes = minutes.toString().padStart(2, "0");
    const value = `${valueHours}:${valueMinutes}`;

    // 12h format for display (e.g. "1:00 PM")
    const displayHours = hours % 12 || 12; // Convert 0 to 12
    const displayMinutes = minutes.toString().padStart(2, "0");
    const ampm = hours < 12 ? "AM" : "PM";
    const label = `${displayHours}:${displayMinutes} ${ampm}`;

    times.push({ label, value, minutes: start });
    start += 15;
  }
  return times;
};

export function TimePicker({ value, onChange, disableBeforeMinutes ,placeHolder}) {
  const times = generateTimes();

  return (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty  // Allows displaying an empty value
        renderValue={(selected) => {
          if (!selected) {
            return <em>{placeHolder}</em>; // Placeholder text (can be styled)
          }
          // Find the selected time's label
          const selectedTime = times.find((time) => time.value === selected);
          return selectedTime?.label || selected;
        }}
      >
        {/* Placeholder option (disabled by default) */}
        {/* <MenuItem disabled value="">
          {placeHolder}
        </MenuItem> */}

        {/* Dynamic time options */}
        {times.map((time) => (
          <MenuItem
            key={time.value}
            value={time.value}
            disabled={
              disableBeforeMinutes !== undefined &&
              time.minutes <= disableBeforeMinutes
            }
            className="time-slot-dropdown"
          >
            {time.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    // <FormControl size="small" sx={{ minWidth: 120 }}>
    //   <Select
    //     value={value}
    //     onChange={(e) => onChange(e.target.value)}
    //     displayEmpty
    //   >
    //     {times.map((time) => (
    //       <MenuItem
    //         key={time.value}
    //         value={time.value}
    //         disabled={
    //           disableBeforeMinutes !== undefined &&
    //           time.minutes <= disableBeforeMinutes
    //         }
    //       >
    //         {time.label}
    //       </MenuItem>
    //     ))}
    //   </Select>
    // </FormControl>
  );
}

// helper: convert "13:45" -> minutes from midnight
export function parseTimeToMinutes(timeString) {
  const [hoursStr, minutesStr] = timeString.split(":");
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);
  return hours * 60 + minutes;
}
